import { buildRoute } from '@direct-frontend/modules-router';

export const constructorRoute = buildRoute('/constructor');
